import { useEffect, useState } from "react";
import BookingDataService from "../../services/Booking";
import ExpertDataService from "../../services/Expert";
import { SingleSubscriptionRow } from "../../components/List/SingleSubscriptionRow";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { UserGroupModel } from "../../components/Modals/UserGroupModel";
export const SubscriptionList = () => {
  const [modal, setModal] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const toast = useToast();
  const localDateSorting =
    localStorage.getItem("subscription-list-sorting-type-content") || false;
  const localExpertFilter =
    localStorage.getItem("subscription-list-filter-expert-content") || "";
  const localSessionFilter =
    localStorage.getItem("subscription-list-filter-session-content") || 0;

  const [list, setList] = useState<any>([]);
  const [initialData, setInitialData] = useState([]);
  const [expertName, SetExpertName] = useState<any>("");
  const [searchData, SetSearchData] = useState("");
  const [lock, setLock] = useState({
    sortingLock: localDateSorting ? true : false,
    leftSessionLock: localSessionFilter ? true : false,
    filterExpertLock: localExpertFilter ? true : false,
  });
  const token = localStorage.getItem("logged_in_user_token");
  const [expert, setExpert] = useState([]);
  const fetchData = async (flag: any) => {
    BookingDataService.getSubscriptionDetails(token)
      .then((res: any) => {
        setList(sortByAlphaBeticalOrder(res.data));
        setInitialData(res.data);
        if (flag) checkLock(res.data);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });

    ExpertDataService.getExperts(token)
      .then((res: any) => {
        setExpert(res.data);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const checkLock = (data: any[]) => {
    if (localDateSorting) {
      sortBySubscriptionEndDateDateAscending(data);
    } else if (localExpertFilter) {
      SetExpertName(localExpertFilter);
      handleExpertFilter(data, localExpertFilter);
    } else if (localSessionFilter) {
      SetSearchData(localSessionFilter);
      handleSessionFilter(data, localSessionFilter);
    }
  };

  const sortByAlphaBeticalOrder = (array: any[]) => {
    array.sort((a, b) => {
      let nameA = a.user_details.first_name.toUpperCase();
      let nameB = b.user_details.first_name.toUpperCase();

      if (nameA < nameB) {
        return -1;
      } else if (nameA > nameB) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  };

  function sortBySubscriptionEndDateDateAscending(array: any[]) {
    const compareDates = (a: any, b: any) => {
      const dateA = new Date(a).getTime();
      const dateB = new Date(b).getTime();
      return dateA - dateB;
    };

    const sortedList = array
      .map((item: any) => ({
        ...item,
        subscriptions_end_dates: item.subscriptions_end_dates
          .slice()
          .sort(compareDates),
      }))
      .sort((a: any, b: any) => {
        const greatestDateA: any = new Date(
          a.subscriptions_end_dates[a.subscriptions_end_dates.length - 1]
        );
        const greatestDateB: any = new Date(
          b.subscriptions_end_dates[b.subscriptions_end_dates.length - 1]
        );
        return greatestDateA - greatestDateB;
      });

    setList(sortedList);
  }

  const handleExpertFilter = (data: any[], expertName: any) => {
    if (expertName !== "") {
      const filteredData = data.filter(
        (el: any) =>
          el.expert_details.full_name.trim().toLowerCase() ===
          expertName.trim().toLowerCase()
      );
      setList(sortByAlphaBeticalOrder(filteredData));
    }
    SetSearchData("");
  };

  const clearFilters = () => {
    SetExpertName("");
    SetSearchData("");
    setLock({
      sortingLock: false,
      leftSessionLock: false,
      filterExpertLock: false,
    });

    localStorage.removeItem("subscription-list-sorting-type-content");
    localStorage.removeItem("subscription-list-filter-expert-content");
    localStorage.removeItem("subscription-list-filter-session-content");
    fetchData(false);
  };

  const handleSessionFilter = (data: any[], searchData: any) => {
    if (searchData !== "") {
      const filteredData = data.filter(
        (el: any) => el.left_bookings === Number(searchData)
      );
      setList(sortByAlphaBeticalOrder(filteredData));
    }
    SetExpertName("");
  };

  useEffect(() => {
    fetchData(true);
  }, []);
  return (
    <div>
      <div className="main-wrapper">
        <div className="page_title py-2">Bookings - Subscriptions</div>

        <div className="p-4">
          {/* Top Section */}
          <div className="top_section_container">
            <div className="top_section_lower_container ">
              <div className="nested  p-lg-0">
                <div className="input-group">
                  <div className="btn-group " role="group">
                    <button
                      type="button"
                      className="btn action-btn pl-4"
                      onClick={() =>
                        sortBySubscriptionEndDateDateAscending(initialData)
                      }
                    >
                      Sorting By Subscription End Date
                    </button>
                  </div>
                  <div className="input-group-append pr-2">
                    {lock.sortingLock ? (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, sortingLock: false });
                          fetchData(false);
                          localStorage.removeItem(
                            "subscription-list-sorting-type-content"
                          );
                        }}
                      >
                        <AiFillLock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    ) : (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, sortingLock: true });
                          sortBySubscriptionEndDateDateAscending(initialData);
                          localStorage.setItem(
                            "subscription-list-sorting-type-content",
                            "true"
                          );
                        }}
                      >
                        <AiFillUnlock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              </div>
            <div className="top_section_lower_container">
              <div className="nested p-lg-0">
                <div className="input-group">
                  <div className="input-group-append subscription_clear_button">
                    <button
                      className="w-100 action-btn"
                      style={{ borderRadius: "2px" }}
                      type="button"
                      onClick={clearFilters}
                    >
                      Clear Filters
                    </button>
                  </div>
                </div>
              </div>
              <div className="nested  p-lg-0">
                <div className="input-group">
                  <div className="input-group-append subscription_clear_button">
                    <button
                      type="button"
                      className="w-100 btn action-btn pl-4"
                      onClick={() => {
                        setModal("usermodal");
                        onOpen();
                      }}
                    >
                      Send notification to a group
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="top_section_lower_container">
              <div className="nested p-lg-0">
                <div className="input-group">
                  <input
                    className="form-control filter-sec"
                    id="lead_status"
                    placeholder="Search by remaining session"
                    value={searchData}
                    onChange={(e) => SetSearchData(e.target.value)}
                  />

                  <div className="input-group-append">
                    <button
                      className="btn action-btn"
                      type="button"
                      onClick={() =>
                        handleSessionFilter(initialData, searchData)
                      }
                    >
                      Search
                    </button>
                  </div>
                  <div className="input-group-append ">
                    {lock.leftSessionLock ? (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, leftSessionLock: false });
                          fetchData(false);
                          localStorage.removeItem(
                            "subscription-list-filter-session-content"
                          );
                        }}
                      >
                        <AiFillLock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    ) : (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, leftSessionLock: true });
                          handleSessionFilter(initialData, searchData);
                          localStorage.setItem(
                            "subscription-list-filter-session-content",
                            searchData
                          );
                        }}
                      >
                        <AiFillUnlock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="nested  p-lg-0 ">
                <div className="input-group">
                  <select
                    className="form-control filter-sec"
                    id="lead_status"
                    value={expertName}
                    onChange={(e) => {
                      SetExpertName(e.target.value);
                    }}
                  >
                    <option value="">Choose Expert</option>
                    {expert.length > 0 &&
                      expert.map((el: any) => (
                        <option value={el.data.full_name}>
                          {el.data.full_name}
                        </option>
                      ))}
                  </select>

                  <div className="input-group-append">
                    <button
                      className="btn action-btn"
                      type="button"
                      onClick={() =>
                        handleExpertFilter(initialData, expertName)
                      }
                    >
                      Search
                    </button>
                  </div>
                  <div className="input-group-append ">
                    {lock.filterExpertLock ? (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, filterExpertLock: false });
                          fetchData(false);
                          localStorage.removeItem(
                            "subscription-list-filter-expert-content"
                          );
                        }}
                      >
                        <AiFillLock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    ) : (
                      <button
                        className="btn action-btn"
                        style={{ backgroundColor: "#308888" }}
                        type="button"
                        onClick={() => {
                          setLock({ ...lock, filterExpertLock: true });
                          handleExpertFilter(initialData, expertName);
                          localStorage.setItem(
                            "subscription-list-filter-expert-content",
                            expertName
                          );
                        }}
                      >
                        <AiFillUnlock
                          style={{ fontSize: "20px", margin: "0 5px" }}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {modal === "usermodal" && (
            <UserGroupModel
              isOpen={isOpen}
              onClose={onClose}
              onOpen={onOpen}
              category={"subscription"}
            />
          )}
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Client Email</th>
                  <th>Expert Name</th>
                  <th>Subscription</th>
                  <th>Count</th>
                  <th>First session date</th>
                  <th>Latest session date</th>
                  <th>Subscription end date</th>
                  <th>Send Notification</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleSubscriptionRow
                      key={el._id}
                      props={el}
                      id={el._id}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
